<template>
   <VLayout wrap>
       <VFlex xs12 v-if="customer">

           <v-divider></v-divider>
           <v-list two-line dense>
               <v-list-item v-for="s in sources" :key="s.id" @click="">
                   <v-list-item-avatar tile >
                       <v-icon color="blue">
                           fab fa-cc-{{s.brand.toLowerCase()}}
                       </v-icon>
                   </v-list-item-avatar>
                   <v-list-item-content>
                       <v-list-item-title>
                           Exp {{s.exp_month}}/{{s.exp_year}}
                       </v-list-item-title>
                       <v-list-item-subtitle>
                           Ending in {{s.last4}} {{s.brand}}
                       </v-list-item-subtitle>
                   </v-list-item-content>
                   <v-list-item-action>
                       <v-checkbox v-model="selectedsource" :value="s.id" />
                   </v-list-item-action>
               </v-list-item>
           </v-list>
           <p>
               <span class="success--text">SELECT (CHECK) PAYMENT METHOD <v-icon class="success--text">{{$store.state.icons.checkoff}}</v-icon></span><br/>
           Use a different card? go to<v-btn text to="/paymentmethods" class="info--text">payment methods</v-btn>.
           We will save your registration when you come back
           </p>
       </VFlex>
       <VFlex xs12 v-else>
            <CreateCustomer  />
       </VFlex>
       <VFlex xs12>
           <BaseBtn @click="createOrder()" :disabled="!selectedsource" :loading="loading">Complete and Pay</BaseBtn>
       </VFlex>
   </VLayout>
</template>

<script>
  import BaseBtn from "../BaseBtn";
  import {
    mapActions,
    mapState
  } from 'vuex'
  import CreateCustomer from "../stripe/CreateCustomer";
  export default {
    components: {CreateCustomer, BaseBtn},
    name: "ConfirmRegistration",
    data() {
      return {
        selectedsource:false,
        email:undefined,
        loading:false
      }
    },
    computed:{
      ...mapState(['event','activesku','customer']),
      players(){
        return this.$store.state.registrants
      },
      evt(){
        return this.event.event
      },
      sources(){
        if(this.customer){
          return this.$store.state.customer.sources.data
        } else {
          return false
        }
      }
    },
    watch:{

    },
    mounted() {

    },
    methods: {
      ...mapActions(['getCustomer','post']),
      async createOrder(){
        if(!this.customer.email&&!this.email)return
        let orderitems={
          "currency": "usd",
          "parent": this.activesku.id,
          "quantity": 1,//per tourney
          "type": "sku"
        };
        let body = {
          items:orderitems,
          eventid:this.evt.id,
          participants:this.players,
          teamname:this.teamname,
          source:this.selectedsource,
          email:this.email
        }
        this.loading=true
        let o = await this.post({body:body,path:'api/payments/stripegeneralusers/eventregistration'})
        this.loading=false
        if(o.error){
          return
        }
        this.$store.commit('setRegistered',o)
        this.$store.commit('setRegistrationStep',1)
        this.$store.commit('setActiveSku',false)
        this.$store.commit('setRegistrants', undefined)
        this.$store.dispatch('getCustomer')
        this.$store.dispatch('getOrders')
        this.$router.replace('/registered')
      }
    }
  }
</script>

<style scoped>

</style>